
const CONF = window?.confPub

export function hasKeycloakRole(token, role) {

    let res = false

    token?.roles?.length > 0 && token?.roles?.map((tokenRole) => {
        res = res ? res : role === tokenRole
    })

    return res
}

export function isAdminKc(token) {

    return hasKeycloakRole(token, CONF?.KEYCLOAK?.ROLES?.ADMIN_FONCTIONNEL)
}

export function isCorrespondantKc(token) {

    return hasKeycloakRole(token, CONF?.KEYCLOAK?.ROLES?.CORRESPONDANT)
}

export function isRenderedAsAdmin(keycloakReduce) {

    return isAdminKc(keycloakReduce?.decodedToken) && keycloakReduce?.isRenderedAsAdmin
}

export function getFirstAndLastNames(token) {

    return `${token?.given_name ?? ''} ${token?.family_name ?? ''}`
}